import { api } from "@/lib/api";

export const STATUSES = [
  "Getting Started", "Credit Analysis", "Disputes Submitted", "Bureau Processing", "Results Coming In",
  "Credit Optimization", "Funding Ready", "Funding in Progress", "Completed",
];

export async function loadClientStats() {
  const [me, intel, msgs, meetings, res, ref] = await Promise.allSettled([
    api.get("/client/me"), api.get("/funding/intel/dashboard"), api.get("/client/messages"), api.get("/client/meetings"), api.get("/client/tradeline-reservations"), api.get("/client/my-referral"),
  ]);
  const v = (r) => (r.status === "fulfilled" ? r.value.data : null);
  const m = v(me) || {};
  const it = v(intel) || {};
  const ms = Array.isArray(v(msgs)) ? v(msgs) : [];
  const mt = Array.isArray(v(meetings)) ? v(meetings) : [];
  const rs = v(res);
  const code = v(ref)?.code;
  const now = Date.now();
  const upcoming = mt.filter((x) => x.scheduled_at && new Date(x.scheduled_at).getTime() > now && !["cancelled", "canceled"].includes(x.status)).sort((a, b) => new Date(a.scheduled_at) - new Date(b.scheduled_at));
  const status = (m.effective_status || m.status || "").replace("Completed After 30 Days", "Completed");
  return {
    name: m.name,
    status,
    stageIndex: Math.max(0, STATUSES.indexOf(status)),
    nextStep: m.next_step,
    specialist: m.assigned_team_member_name,
    fundingiq: it.fundingiq,
    availableToday: it.available_today,
    readiness: it.readiness_score,
    messageCount: ms.length,
    lastMessage: ms.length ? `${ms[ms.length - 1].sender_name}: ${ms[ms.length - 1].text}`.slice(0, 90) : null,
    upcomingMeetings: upcoming.length,
    nextMeeting: upcoming[0]?.scheduled_at || null,
    reservations: Array.isArray(rs) ? rs.length : Array.isArray(rs?.reservations) ? rs.reservations.length : 0,
    referralCode: code?.code || null,
    referralSignups: code?.signups ?? 0,
    referralClicks: code?.clicks ?? 0,
  };
}

export function personalize(text, stats, user) {
  if (!text) return text;
  const first = (stats?.name || user?.name || "friend").split(" ")[0];
  return text
    .replace(/\{name\}/g, first)
    .replace(/\{iq\}/g, stats?.fundingiq != null ? String(stats.fundingiq) : user ? "pending" : "unlocked at signup")
    .replace(/\{stage\}/g, stats?.status || (user ? "Getting Started" : "not started yet"))
    .replace(/\{coins\}/g, "0");
}
